import React, { Component } from 'react'
import './report.css'
import { Helmet } from "react-helmet";

export default class Report extends Component {
  constructor() {
    super()
    this.state = {
      category: 'error',
    }

    this.setState = this.setState.bind(this)
  }


  render() {
    return (
      <div className="card report">
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        {this.props.query && this.props.query.completed ?
          <div className="complete" style={{textAlign: 'center'}}>
            Your report has been received. We appreciate your help in making Streamable a lawful, positive community.
            <div style={{textAlign: 'center', marginTop: '10px'}}>
              <a href='https://streamable.com'>
                Go Home
              </a>
            </div>
          </div>
          :
          <form className="form" name="report" action={`${process.env.REACT_APP_API_HOST}/${this.props.shortcode}/report`} method="POST">
            <h3>What's wrong with this video?</h3>
            <div>
              <div className="form-group">
                <label><input type="radio" name="category" value="error" checked={this.state.category === 'error'} onChange={(e) => this.setState({ category: 'error' })}></input>Video won't play on my device</label>
              </div>
              <div className="form-group">
                <label><input type="radio" name="category" value="violence" checked={this.state.category === 'violence'} onChange={(e) => this.setState({ category: 'violence' })}></input>Promotes violence or terrorism</label>
              </div>
              <div className="form-group">
                <label><input type="radio" name="category" value="xxx" checked={this.state.category === 'xxx'} onChange={(e) => this.setState({ category: 'xxx' })}></input>Pornography or graphic content</label>
              </div>
              <div className="form-group">
                <label><input type="radio" name="category" value="dmca" checked={this.state.category === 'dmca'} onChange={(e) => this.setState({ category: 'dmca' })}></input>Copyright infringement</label>
              </div>
              <div className="form-group">
                <label><input type="radio" id="quality" name="category" value="quality" checked={this.state.category === 'category'} onChange={(e) => this.setState({ category: 'category' })}></input>Quality problems</label>
              </div>
              <div className="form-group">
                <label><input type="radio" id="other" name="category" value="other" checked={this.state.category === 'other'} onChange={(e) => this.setState({ category: 'other' })}></input>Something else</label>
              </div>
            </div>
            
            <div className="form-group" style={{marginTop:"20px"}}>
              {this.state.category !== 'dmca'
              ?
                <textarea className="form-control" rows="5" id="comment" name="comment" placeholder="additional details"></textarea>
              :
                <div id="dmca-alert">Please file a DMCA notification as detailed here: <a href='https://terms.streamable.com/#dmca'>https://terms.streamable.com/#dmca</a></div>
              }
            </div>
            
            <div className="form-group" style={{marginTop:"20px", textAlign: "center"}}>
              <input type="submit" className="btn btn-primary btn-sm" style={{padding:"6px 14px"}}></input>
            </div>
          </form>
        }
      </div>
    )
  }
}

